/**
 * Web-only file download helpers. Native (Capacitor) platforms need the
 * Filesystem/Share plugins instead; callers should hide download UI there.
 */

export const parseContentDispositionFilename = (
  header: string | undefined
): string | null => {
  if (!header) return null;
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header);
  return match ? decodeURIComponent(match[1]) : null;
};

export const saveBlobToFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
